// extracted by mini-css-extract-plugin
export default {"container":"NewForm_container__TFpYw","content":"NewForm_content__gMGuD","button":"NewForm_button__JQInw","accent":"NewForm_accent__kfh8S","pressed":"NewForm_pressed__LyV1I"};